import LightbulbIcon from '@atlaskit/icon/core/lightbulb';
import * as React from 'react';

export function SvgBulb() {
  return <LightbulbIcon label="" testId="ads-refreshed-icon" />;
}
